import React from 'react';

import styles from './Checkbox.module.css';

export const Checkbox = ({
  checkboxLabelCustom = '',
  checked = false,
  className = '',
  id = '',
  label = '',
  onChange = () => { },
}) => {
  function toggle() {
    onChange(!checked);
  }

  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={`${styles.mainContainer} ${className}`}
      id={`checkbox${id}-label`}
    >
      <input
        checked={checked}
        id={id}
        name={label}
        onChange={toggle}
        type="checkbox"
      />

      <span className={checkboxLabelCustom}>{label}</span>
    </label>
  );
};

export default Checkbox;
